import { render, staticRenderFns } from "./ProduktKontaktformular.vue?vue&type=template&id=a7659fde&"
import script from "./ProduktKontaktformular.vue?vue&type=script&lang=js&"
export * from "./ProduktKontaktformular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports